<template>
    <content-page title="Φιλοσοφία" icon="mdi-basketball" :loading="!philosophy">
        <div v-if="philosophy" v-html="philosophy.content" />
    </content-page>
</template>

<script>
    import configService from '@/services/config'
    import ContentPage from '@/components/ContentPage'
    export default {
        components: { ContentPage },
        data() {
            return {
                philosophy: null
            }
        },
        created() {
            this.getPhilosophy()
        },
        methods: {
            getPhilosophy() {
                configService.getConfigField('philosophy').then(resp => {
                    this.philosophy = resp.data
                })
            }
        }
    }
</script>
